export default function getResource(label, vars = []) {
    const resources = {
        standard: 'À expédier'
    };
    return resources[label];
}
